import { makeStyles } from "tss-react/mui"
import { Box, Typography } from "@mui/material"
import { faUser } from "@fortawesome/pro-regular-svg-icons"

import { LocalizedStrict } from "../../../../../../modules/localization/components/AppLocalized"
import { useAppSelector } from "../../../../../../modules/store/storeHooks"
import { selectLoginUser } from "../../../../../../modules/users/userSelectors"

import { TakeawayCheckoutSectionHeader } from "./TakeawayCheckoutSectionHeader"

const useStyles = makeStyles()((theme) => ({
    rows: {
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
    },
    row: {
        display: "flex",
        flexWrap: "wrap",
        gap: ".25rem",
        color: theme.palette.tailwind.slate[950],
    },
    value: {
        fontWeight: 700,
    },
}))

export function useHasTakeawayPersonalInfo() {
    const user = useAppSelector(selectLoginUser)
    return Boolean(user?.displayName || user?.email || user?.phoneNumber || user?.mobileNumber)
}

export function TakeawayCheckoutPersonalInfoSection() {
    const { classes } = useStyles()
    const user = useAppSelector(selectLoginUser)

    const name = user?.displayName
    const email = user?.email
    const phone = user?.mobileNumber ?? user?.phoneNumber

    if (!name && !email && !phone) return null

    return (
        <Box>
            <TakeawayCheckoutSectionHeader
                icon={faUser}
                title={
                    <LocalizedStrict id="takeaway-confirm-order-personal-info-title">
                        <span>Personal Information</span>
                    </LocalizedStrict>
                }
            />
            <Box className={classes.rows}>
                {name && (
                    <Box className={classes.row}>
                        <LocalizedStrict id="takeaway-confirm-order-personal-info-name-label">
                            <Typography variant="body1">Name:</Typography>
                        </LocalizedStrict>
                        <Typography variant="body1" className={classes.value}>
                            {name}
                        </Typography>
                    </Box>
                )}
                {email && (
                    <Box className={classes.row}>
                        <LocalizedStrict id="takeaway-confirm-order-personal-info-email-label">
                            <Typography variant="body1">Email:</Typography>
                        </LocalizedStrict>
                        <Typography variant="body1" className={classes.value}>
                            {email}
                        </Typography>
                    </Box>
                )}
                {phone && (
                    <Box className={classes.row}>
                        <LocalizedStrict id="takeaway-confirm-order-personal-info-phone-label">
                            <Typography variant="body1">Phone Number:</Typography>
                        </LocalizedStrict>
                        <Typography variant="body1" className={classes.value}>
                            {phone}
                        </Typography>
                    </Box>
                )}
            </Box>
        </Box>
    )
}
